import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PROJECT, TrackingEventName, UploadPhotoOptionsModalViewTrackingEvent } from "./tracking";

interface TrackUploadPhotoOptionsModalViewFunction {
  (): void;
}

interface UseTrackUploadPhotoOptionsModalViewFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly customerId: string;
  readonly tradename: Tradename;
}

interface UseTrackUploadPhotoOptionsModalViewFunction {
  (agrs: UseTrackUploadPhotoOptionsModalViewFunctionArgs): TrackUploadPhotoOptionsModalViewFunction;
}

const useTrackUploadPhotoOptionsModalView: UseTrackUploadPhotoOptionsModalViewFunction = ({
  country,
  segment,
  customerId,
  tradename,
}) => {
  const emitUserEvent = useEmitUserEvent<UploadPhotoOptionsModalViewTrackingEvent>();

  const trackUploadPhotoOptionsModalView: TrackUploadPhotoOptionsModalViewFunction = useCallback(() => {
    emitUserEvent({
      event: TrackingEventName.UPLOAD_PHOTO_OPTIONS_MODAL_VIEW,
      eventCategory: TrackingEventCategory.NAVIGATION,
      section: `${PROJECT}_photos`,
      store: country,
      segment,
      userId: customerId,
      tradename,
    });
  }, [country, emitUserEvent, customerId, tradename, segment]);

  return trackUploadPhotoOptionsModalView;
};

export { useTrackUploadPhotoOptionsModalView };
